import { render } from "./BorderLine.vue?vue&type=template&id=630e246b&scoped=true&ts=true"
import script from "./BorderLine.vue?vue&type=script&lang=ts"
export * from "./BorderLine.vue?vue&type=script&lang=ts"

import "./BorderLine.vue?vue&type=style&index=0&id=630e246b&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630e246b"]])

export default __exports__